export default __webpack_public_path__ + "static/media/bg-home.18565f43.mp4";